/** Shared font sizes for TipTap Size menus. */
export const RICH_TEXT_FONT_SIZES = [
  { label: 'Default', value: '' },
  { label: 'Small', value: '12px' },
  { label: 'Normal', value: '16px' },
  { label: 'Large', value: '20px' },
  { label: 'Extra large', value: '24px' },
  { label: 'Title', value: '32px' },
]

export const RICH_TEXT_COLOURS = [
  { label: 'Default', value: '' },
  { label: 'Navy', value: '#1e3a5f' },
  { label: 'Red', value: '#b91c1c' },
  { label: 'Green', value: '#15803d' },
  { label: 'Amber', value: '#b45309' },
  { label: 'Blue', value: '#1d4ed8' },
]

/**
 * Apply font size without nested chain().run() (TipTap FontSize's setFontSize
 * already calls run internally, which breaks editor.chain()…setFontSize().run()).
 * Pass a saved { from, to } selection captured when the Size menu was opened.
 */
export function applyFontSize(editor, size, selection) {
  if (!editor) return
  let chain = editor.chain().focus()
  if (selection && typeof selection.from === 'number' && typeof selection.to === 'number') {
    chain = chain.setTextSelection(selection)
  }
  if (!size) {
    chain.setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run()
  } else {
    chain.setMark('textStyle', { fontSize: size }).run()
  }
}

export function applyColour(editor, colour, selection) {
  if (!editor) return
  let chain = editor.chain().focus()
  if (selection && typeof selection.from === 'number' && typeof selection.to === 'number') {
    chain = chain.setTextSelection(selection)
  }
  if (!colour) {
    chain.setMark('textStyle', { color: null }).removeEmptyTextStyle().run()
  } else {
    chain.setMark('textStyle', { color: colour }).run()
  }
}

/** Capture selection before a native <select> steals focus from the editor. */
export function captureEditorSelection(editor) {
  if (!editor) return null
  const { from, to } = editor.state.selection
  return { from, to }
}
